<!-- <label class="label-txt" for="status">Status</label> -->
<div class="d-flex searchlist-drp">
   <div class="select-status">
      <select floatinputModel class="form-control input" id="status" [(ngModel)]="options" (change)="onSelectOption()">
         <!-- (change)="onStatusChange()"> -->
         <option *ngFor="let data of searchOptions" value="{{data}}">{{data}}
         </option>
      </select>
   </div>
   <div class="search-nav">
      <input class="form-control kg-custm-search" type="text" placeholder="Search.." aria-label="Search" type="text"
         [(ngModel)]="search" typeaheadOptionField="result" [typeahead]="suggestions$" [typeaheadAsync]="true"
          (typeaheadOnSelect)="typeaheadInvoiceOnSelect($event)"
         [typeaheadMinLength]="2" [typeaheadHideResultsOnBlur]="false" [typeaheadWaitMs]="300"
         (keydown)="keydown($event)">
         
      <i class="fa fa-search" aria-hidden="true">
         <span class="fa fa-spinner fa-spin" *ngIf="isLoadingResults"></span>
      </i>

   </div>
</div>